import { CodeSnippet } from 'components/code-snippet'
import { ProjectSnippetProps } from 'modules/project/types/project-snippet-props.type'
import { memo } from 'react'

export const HtmlSnippet: React.FC<ProjectSnippetProps> = memo(({ url }) => {
    return <CodeSnippet language="html" label="HTML">{`<script src="${url}" defer></script>`}</CodeSnippet>
})
HtmlSnippet.displayName = 'HtmlSnippet'
